





























import { Component, Prop, Ref, Vue } from 'vue-property-decorator'

@Component({})
export default class InitialQuizStage extends Vue {
  @Prop() private readonly debugMode?: boolean
  @Prop() private readonly score!: string
  @Prop() private readonly stage!: IInitialQuizStage

  @Ref('input') readonly refInput!: HTMLButtonElement

  mounted() {
    this.refInput.focus()
  }

  changeAnswerOf(answer: string) {
    this.stage.userAnswer = answer
    this.stage.correct = this.stage.answer === answer
  }

  pressEnterKey() {
    // this.$emit('onPressEnterKey')
    return
  }

  get initialsAsArray() {
    return this.stage.initial.split('')
  }
}
